import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { parseMyStudentsLocation } from '../../services/teacherStudentsApi';
import { CourseList, CourseManage, GroupPage, Landing, PathList, PathManage, StudentProfile } from './TeacherMyStudentsViews';
import './TeacherSections.css';
import './TeacherMyStudents.css';

const TeacherSectionMyStudents = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const route = useMemo(() => parseMyStudentsLocation(location.pathname), [location.pathname]);
  const go = (path) => navigate(path);

  if (route.view === 'learning-paths') return <PathList go={go} />;
  if (route.view === 'path') return <PathManage go={go} pathId={route.pathId} />;
  if (route.view === 'courses') return <CourseList go={go} />;
  if (route.view === 'course') return <CourseManage go={go} courseId={route.courseId} />;
  if (route.view === 'group') return <GroupPage go={go} groupId={route.groupId} pathId={route.pathId} courseId={route.courseId} />;
  if (route.view === 'student') {
    return (
      <StudentProfile
        go={go}
        studentId={route.studentId}
        groupId={route.groupId}
        pathId={route.pathId}
        courseId={route.courseId}
      />
    );
  }
  return <Landing go={go} />;
};

export default TeacherSectionMyStudents;
